import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#FF6699', '#33CC99', '#AA66CC'];

/** Reusable share pie chart for {name, value} slices. */
export function SharePie({ data, height = 300 }: { data: { name: string; value: number }[]; height?: number }) {
  if (data.every((d) => d.value === 0)) {
    return <div className="flex items-center justify-center text-gray-500" style={{ height }}>No data in range</div>;
  }
  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart>
        <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={100} label>
          {data.map((_, i) => (
            <Cell key={i} fill={COLORS[i % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
}
